<template>
  <div class="home-partners">
    <a href="/html/special/partner2026/" target="_blank">
      <img class="partners-badge" :src="badge" />
    </a>
    <div class="partners-box">
      <div class="partners-track-wrapper">
        <!-- 单一 track，包含第一份和第二份重复数据 -->
        <div class="partners-track" ref="track">
          <!-- 第一份数据 -->
          <div v-for="item in partners" :key="'a-' + (item.id || item.name)" class="partner-item">
            <a :href="item.turnUrl" target="_blank" @click.prevent="openLink(item.turnUrl)" class="partner-link">
              <img :src="item.imageUrl" :alt="item.name" />
            </a>
            <span class="partner-name">{{ item.name }}</span>
          </div>
          <!-- 第二份数据（用于无缝衔接） -->
          <div v-for="item in partners" :key="'b-' + (item.id || item.name)" class="partner-item">
            <a :href="item.turnUrl" target="_blank" @click.prevent="openLink(item.turnUrl)" class="partner-link">
              <img :src="item.imageUrl" :alt="item.name" />
            </a>
            <span class="partner-name">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../../../api/request'

export default {
  name: 'HomePartners',
  data() {
    return {
      badge: require('../img/FigmaDDSSlicePNG05a24546742e3f0a8b1580fcedcd75e5.png'),
      partners: [],
      scrollIndex: 0,
      timer: null,
      isScrolling: false,
      isSafari: false
    }
  },
  mounted() {
    // 检测是否为 Safari 浏览器
    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    
    this.loadPartners()
    
    // 在 Safari 中，使用 requestAnimationFrame 优化渲染
    if (this.isSafari) {
      this.$nextTick(() => {
        this.forceRepaint()
      })
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    forceRepaint() {
      // 强制浏览器重绘，解决 Safari 初始渲染延迟问题
      const track = this.$refs.track
      if (track) {
        // 触发重排
        track.style.transform = 'translateZ(0)'
        track.offsetHeight
        track.style.transform = ''
      }
    },
    async loadPartners() {
      try {
        const res = await request.post('/api/index/getPartnerList')
        if (res.code === 200 && res.data && Array.isArray(res.data)) {
          this.partners = res.data.map((item, index) => ({
            id: item.id || `partner-${index}`,
            name: item.name || '未知名称',
            imageUrl: item.imageUrl || '',
            turnUrl: item.turnUrl || '#'
          }))
          
          if (this.partners.length < 6) {
            this.partners = this.partners.concat(this.getFallbackPartners(6 - this.partners.length))
          }
          
          if (this.partners.length > 0) {
            // 等待 DOM 更新后再启动滚动
            this.$nextTick(() => {
              // Safari 需要额外延迟
              const delay = this.isSafari ? 300 : 0
              setTimeout(() => {
                this.startScroll()
              }, delay)
            })
          }
        }
      } catch (e) {
        console.error('合作伙伴加载失败:', e)
        this.partners = this.getFallbackPartners(6)
        if (this.partners.length > 0) {
          this.$nextTick(() => {
            const delay = this.isSafari ? 300 : 0
            setTimeout(() => {
              this.startScroll()
            }, delay)
          })
        }
      }
    },
    getFallbackPartners(count) {
      return [
        { id: 'default-1', logo: require('../img/FigmaDDSSlicePNGde9c0cc5418f0a45f35b76be2cd1ab1a.png'), name: '中国石油化工集团' },
        { id: 'default-2', logo: require('../img/FigmaDDSSlicePNG56cc0b160f8aa84290d046f1b0e6f433.png'), name: '中国石油天然气集团' },
        { id: 'default-3', logo: require('../img/FigmaDDSSlicePNG1c089ce6cb7e194b6d947f407c2d8469.png'), name: '中国海洋石油集团' },
        { id: 'default-4', logo: require('../img/FigmaDDSSlicePNG28bb70b0fd1a42910e1813fe2846bc91.png'), name: '中国神华能源' },
        { id: 'default-5', logo: require('../img/FigmaDDSSlicePNG28bb70b0fd1a42910e1813fe2846bc91.png'), name: '中国神华能源' },
        { id: 'default-6', logo: require('../img/FigmaDDSSlicePNG1c089ce6cb7e194b6d947f407c2d8469.png'), name: '中国海洋石油集团' }
      ].slice(0, count)
    },
    startScroll() {
      // 清除旧的定时器
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      
      // Safari 使用更长的间隔，让动画更平滑
      const interval = this.isSafari ? 4000 : 3000
      
      // 启动定时器
      this.timer = setInterval(() => {
        this.scrollNext()
      }, interval)
    },
    scrollNext() {
      if (this.isScrolling || this.partners.length === 0) return
      
      this.isScrolling = true
      
      const nextIndex = (this.scrollIndex + 1) % this.partners.length
      const track = this.$refs.track
      if (!track) {
        this.isScrolling = false
        return
      }
      
      const itemWidth = 198
      
      if (nextIndex < this.scrollIndex) {
        // 从最后回到开头
        track.style.transition = 'none'
        track.style.transform = 'translateX(0px)'
        this.scrollIndex = 0
        
        // 使用 requestAnimationFrame 确保在 Safari 中流畅
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.isScrolling = false
          })
        })
      } else {
        // 正常滚动
        const offset = nextIndex * itemWidth
        
        // Safari 优化：使用 will-change 提示浏览器
        if (this.isSafari) {
          track.style.willChange = 'transform'
        }
        
        // 使用 requestAnimationFrame 确保在 Safari 中平滑
        requestAnimationFrame(() => {
          track.style.transition = `transform ${this.isSafari ? 4 : 3}s cubic-bezier(0.25, 0.46, 0.45, 0.94)`
          track.style.transform = `translateX(-${offset}px)`
        })
        
        setTimeout(() => {
          this.scrollIndex = nextIndex
          this.isScrolling = false
          
          // 移除 will-change 避免内存泄露
          if (this.isSafari) {
            setTimeout(() => {
              track.style.willChange = 'auto'
            }, 100)
          }
        }, this.isSafari ? 4000 : 3000)
      }
    },
    openLink(href) {
      if (href && href !== '#') {
        window.open(href, '_blank')
        return false
      }
    }
  }
}
</script>

<style scoped>
.home-partners {
  width: 1400px;
  height: 160px;
  margin: 0 auto;
  border-radius: 10px;
  background-image: linear-gradient(
    180deg,
    rgba(250, 246, 229, 1) 0,
    rgba(242, 199, 166, 1) 100%
  );
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-top: 30px;
  flex-shrink: 0;
  /* Safari 优化：启用硬件加速 */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}
.partners-badge {
  width: 130px;
  height: 102px;
  margin-left: 20px;
  flex-shrink: 0;
}
.partners-box {
  width: 1216px;
  height: 120px;
  margin-left: 16px;
  margin-right: 18px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 60px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  /* Safari 优化：启用硬件加速 */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}
.partners-track-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  margin-left: 15px;
}
.partners-track {
  display: flex;
  align-items: center;
  height: 100%;
  white-space: nowrap;
  /* Safari 优化：使用 will-change 提示浏览器 */
  will-change: transform;
  /* Safari 优化：启用硬件加速 */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  /* 初始状态，等待 JS 控制动画 */
  transition: none;
}
.partner-item {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 15px;
  width: 168px;
  flex-shrink: 0;
  height: 100%;
  /* Safari 优化：防止子元素重绘 */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}
.partner-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 58px;
  flex-shrink: 0;
  width: 100%;
}
.partner-item img {
  width: 100%;
  max-width: 160px;
  height: 58px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
  /* Safari 优化：图片渲染优化 */
  image-rendering: auto;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}
.partner-name {
  height: 18px;
  font-family: 'Microsoft YaHei UI', 'Microsoft YaHei UI';
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  text-align: center;
  font-style: normal;
  text-transform: none;
  line-height: 18px;
  margin-top: 5px;
  flex-shrink: 0;
  white-space: nowrap;
}
</style>